// @flow

import handleActions                               from 'redux-actions/lib/handleActions';
import type { Reducer }                            from 'redux-immutable';
import { combineReducers }                         from 'redux-immutable';
import displayPersonalisedDataClearedMessageAction from '../actions/displayPersonalisedDataClearedMessage';
import hideIsPersonalisedMessageAction             from '../actions/hideIsPersonalisedMessage';
import hidePersonalisedDataClearedMessageAction    from '../actions/hidePersonalisedDataClearedMessage';
import isPersonalisedAction                        from '../actions/isPersonalised';

// -----------------------------------------------------------------------------------------------------------------
// Reducers
// -----------------------------------------------------------------------------------------------------------------

const isPersonalised: Reducer = handleActions(
  {
    [String(isPersonalisedAction)]: () => true,
  },
  false,
);

const hideIsPersonalisedMessage: Reducer = handleActions(
  {
    [String(hideIsPersonalisedMessageAction)]: () => true,
  },
  false,
);

const displayPersonalisedDataClearedMessage: Reducer = handleActions(
  {
    [String(displayPersonalisedDataClearedMessageAction)]: () => true,
    [String(hidePersonalisedDataClearedMessageAction)]:    () => false,
  },
  false,
);

export default combineReducers({isPersonalised, hideIsPersonalisedMessage, displayPersonalisedDataClearedMessage});



// WEBPACK FOOTER //
// ./src/modules/personalContent/store/reducers/index.js